import request from '@/utils/request'

export const getUsers = (role: string, params: any) =>
  request({
    url: '/statistics/roles.show?role=' + role,
    method: 'get',
    params
  })

export const hide = (id: number, status: boolean) =>
  request({
    url: '/service_providers.hide',
    method: 'post',
    data: {
      id: id,
      status: status
    }
  })
